import Quiz from './Quiz';
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./components')

window.Vue = require('vue');

if (process.env.MIX_BUGSNAG_API_KEY) {
    const bugsnagClient = bugsnag(process.env.MIX_BUGSNAG_API_KEY)
    bugsnagClient.use(bugsnagVue, Vue)
}

Vue.mixin(require('./mixins/helpers'))

;(function () {
    this.CreateQuiz = function () {
        return new Quiz
    }
}.call(window))

let $window = $(window), $body = $('body');
$window.on('load', function() {
    $body.removeClass('preloading');
});

$window.on('resize', function() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
}).trigger('resize');

$(document).on('opening', '.avatar-remodal', function () {
    window.Quiz.$emit('avatar-swiper-created')
});